import React from "react";
import { useHistory } from "react-router-dom";
import { useAccount } from "utils/AccountInfoContext";
import Header from "../components/Header";
import ReviewItemList from "../components/ReviewItemList";
import styles from "./PlatinumSettingsPage.module.css";
import { useTranslation } from "react-i18next";

export function PlatinumSettingsPage() {
  const {t} = useTranslation();
  const history = useHistory();
  const { subEntityData } = useAccount();

  const handleOnReview = (id) => {
    history.push(`/review-address/${id}`);
  };

  const entityData = subEntityData.map((item) => ({
    entityId: item.entityId,
    address: item.address,
    name: item.name,
    nameOnAccount: item.bankInfo?.nameOnAccount,
    lastFour: item.bankInfo?.lastFour || "",
    bankRequired: item.bankRequired,
    w9Required: item.w9Required,
    emailStatus: item.emailStatus,
    addressStatus: item.addressStatus,
    w9Status: item.w9Status,
    achStatus: item.achStatus,
  }));

  const handleHeaderBackClick = () => {
    history.push("/");
  };

  return (
    <div className={styles.container}>
      <Header
        header={t("Settings")}
        onClick={handleHeaderBackClick}
        className={styles.header}
      />
      <div className={styles.headerContainer}>
        <span className={styles.headerTitle}>{t("Review/Update Your Entity")}</span>
      </div>
      <p className={styles.body}>
        {t("Every year we ask all our IBOs to validate info")}
      </p>
      <br></br>
      <p className={styles.body}>
        {t("If you need to add, replace, or remove entity")}{" "}
        <a href="mailto:amm@wwdb.com">amm@wwdb.com.</a>
      </p>
      <ReviewItemList
        items={entityData}
        header={t("My Entities to Review")}
        onReview={handleOnReview}
      />
    </div>
  );
}

export default PlatinumSettingsPage;
